import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/Logo.jpeg";

// Front page of app.otalife.app. Replaces the old Native welcome/login pages, whose
// login went to the dead auth.be-native.life. Links only to working parts of the site.

const DELHI_EVENT_ID = "cmsrr6udn007xs60i5vj9wzyi"; // Ota TOKYO 2026 Delhi, Nov 28-29
const APP_STORE_URL = "https://apps.apple.com/in/app/ota-life/id6743555476";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.otanative.ota";

const Card = ({ to, href, onClick, emoji, title, text }) => {
  const className =
    "flex items-center gap-4 w-full rounded-2xl border border-gray-200 bg-white p-4 shadow-sm hover:shadow-md transition text-left";
  const body = (
    <>
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-[#3969E7] to-[#7D2AE7] text-2xl">
        {emoji}
      </div>
      <div className="min-w-0">
        <p className="text-base font-bold text-gray-900">{title}</p>
        <p className="text-sm text-gray-500">{text}</p>
      </div>
      <span className="ml-auto text-xl text-gray-400">›</span>
    </>
  );
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={className} data-testid={`home-${title}`}>
        {body}
      </button>
    );
  }
  return to ? (
    <Link to={to} className={className} data-testid={`home-${title}`}>
      {body}
    </Link>
  ) : (
    <a href={href} className={className} target="_blank" rel="noopener noreferrer">
      {body}
    </a>
  );
};

export default function Home() {
  const navigate = useNavigate();

  // Same flow as the event page's Reserve button: the event API needs a login, so
  // remember the event, then go to checkout (or to login first).
  const buyTickets = () => {
    localStorage.setItem("eventId", DELHI_EVENT_ID);
    navigate(localStorage.getItem("JWTtoken") ? "/events/checkout" : "/events/login");
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F5F3FF] to-white" data-testid="home-page">
      <div className="mx-auto flex max-w-md flex-col items-center px-5 pb-10 pt-14">
        <img src={Logo} alt="Ōta LIFE" className="h-20 w-20 rounded-2xl shadow" />
        <h1 className="mt-5 text-3xl font-extrabold text-gray-900">Ōta LIFE</h1>
        <p className="mt-1 text-center text-gray-500">Your anime and Japanese pop culture community</p>

        <div className="mt-8 flex w-full flex-col gap-3">
          <Card
            onClick={buyTickets}
            emoji="🎟️"
            title="Ōta TOKYO 2026 Delhi tickets"
            text="Nov 28-29, Yashobhoomi (IICC), Delhi"
          />
          <Card to="/shop-owner/login" emoji="🏪" title="Merchant Hub" text="For booth owners and exhibitors" />
        </div>

        <p className="mt-8 text-sm font-semibold text-gray-700">Get the Ōta LIFE app</p>
        <p className="mt-1 text-center text-xs text-gray-500">Your tickets, quizzes, rewards and more. Tickets work offline.</p>
        <div className="mt-3 flex w-full gap-3">
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="flex-1 rounded-xl bg-black px-4 py-3 text-center text-sm font-semibold text-white">
             App Store
          </a>
          <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="flex-1 rounded-xl bg-black px-4 py-3 text-center text-sm font-semibold text-white">
            ▶ Google Play
          </a>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-gray-400">
          <a href="/privacy-policy">Privacy Policy</a>
          <Link to="/terms-and-conditions">Terms of Service</Link>
          <Link to="/tokushoho">Specified Commercial Transactions Act</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </div>
    </div>
  );
}
